<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                id="102">
                    <h2 >विवाद </h2>
                </div>
                <div class="col-md-2 col2"><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12">
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-3">
                    
                    <label for="" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id="102">विवाद दो या दो से अधिक पक्षों के बीच असहमति या संघर्ष को संदर्भित करता है जो राय, हितों या व्याख्याओं में अंतर से उत्पन्न हो सकता है। विवाद विभिन्न संदर्भों में हो सकते हैं, जिनमें व्यक्तिगत संबंध, व्यावसायिक लेनदेन, कानूनी मामले और बहुत कुछ शामिल हैं। वे छोटी असहमतियों से लेकर बड़े विवादों तक हो सकते हैं जिनके लिए औपचारिक समाधान प्रक्रियाओं की आवश्यकता होती है। </label>

                    <label for="" class="mt-4" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="103" ><b>विवाद और चार्जबैक: </b>&nbsp;विवाद,
                        जिसे चार्जबैक के रूप में भी जाना जाता है, तब होता है जब कोई ग्राहक अपने
                        क्रेडिट या डेबिट कार्ड विवरण पर दिखाई देने वाले शुल्क पर सवाल उठाता है या
                        विवाद करता है। ऐसा कई कारणों से हो सकता है, जैसे आरोप को न पहचानना, धोखाधड़ी
                        वाली गतिविधि का संदेह करना, या प्राप्त उत्पाद या सेवा से असंतुष्ट होना। जब
                        कोई विवाद शुरू होता है, तो पे जी सहित भुगतान प्रोसेसर, मामले की जांच करने और
                        इसमें शामिल दोनों पक्षों के लिए इसे निष्पक्ष रूप से हल करने के लिए बाध्य है।
                    </label>

                    <label for="" class="mt-4" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="104"><b>धोखाधड़ी की रोकथाम:</b>&nbsp; ऑनलाइन
                        भुगतान उद्योग में धोखाधड़ी एक गंभीर चिंता का विषय है। इसमें व्यक्तियों या
                        समूहों द्वारा बुरे इरादों से किए गए अनधिकृत या धोखाधड़ी वाले लेनदेन शामिल
                        हैं। ये लेनदेन ग्राहकों और व्यापारियों दोनों के लिए हानिकारक हो सकते हैं,
                        जिससे वित्तीय नुकसान हो सकता है और भुगतान प्रक्रिया में ग्राहक का भरोसा टूट
                        सकता है। धोखाधड़ी से निपटने के लिए, पे जी उन्नत धोखाधड़ी रोकथाम उपाय अपनाता
                        है। इन उपायों में परिष्कृत एल्गोरिदम और प्रौद्योगिकियां शामिल हैं जो संभावित
                        धोखाधड़ी गतिविधियों की पहचान करने के लिए लेनदेन पैटर्न, आईपी अड्रेस, डिवाइस
                        जानकारी और बहुत कुछ का विश्लेषण करती हैं। यदि कोई लेनदेन लाल झंडे उठाता है,
                        तो इसे आपके व्यवसाय और ग्राहक दोनों की सुरक्षा के लिए आगे की समीक्षा के लिए
                        चिह्नित किया जा सकता है या यहां तक कि अवरुद्ध भी किया जा सकता है।


                    </label>

                    <label for="" >विवाद और धोखाधड़ी की रोकथाम ऑनलाइन लेनदेन के अभिन्न
                        पहलू हैं और उन्हें समझने से हमें आपके ग्राहकों के लिए एक सहज और सुरक्षित
                        भुगतान अनुभव सुनिश्चित करने के लिए मिलकर काम करने में मदद मिल सकती है। यदि
                        आपके पास इन मामलों के संबंध में कभी कोई प्रश्न या चिंता है, तो कृपया संपर्क
                        करने में संकोच न करें। हम हर कदम पर आपका समर्थन करने के लिए यहां हैं।
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        विषयसूची:
                    </h5>
                </div>
                <!-- <div class="col-md-12 mt-2">
                    <a href="#1"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10">
                            <span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                E-Agreement </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-3">
                    <a href="#102">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">
                                    विवाद क्या हैं?  </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#103">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">विवाद और चार्जबैक
                                </span>
                            </div>
                        </div>
                    </a>
                </div>

                <div class="col-md-12 mt-3 ">
                    <a href="#104">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">धोखाधड़ी की रोकथाम
                                </span>
                            </div>
                        </div>
                    </a>
                </div>



            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                
                <a [routerLink]="['/refunds']"><button class="btn btn-color" (click)="menues('Refunds')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;रिफंड
                </button></a>
            </div>
            <div class="col-md-4   ">
            
                <a [routerLink]="['/pay-profile']"> <button class="btn btn-color" (click)="menues('Pay Profile')" >पे
                    प्रोफाईल
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>

        </div>
    </div>
</div>